var logpopup = document.getElementById('login-popup');
var regpopup = document.getElementById('register-popup');
var loginform = document.getElementById('login-form');
var recoverform = document.getElementById('recover-form');
var regback = document.getElementById('register-back');
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 992 ) {
    if(document.getElementById('acc-click')) document.getElementById('acc-click').addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('body').classList.toggle('active-popup');
      document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter','open-currency');
      if(document.querySelector('.account-popup-wraper').classList.contains('active-register')){
        let height = document.querySelector('.register-popup-wrap').offsetHeight;
        document.querySelector('.account-popup-wraper').style.height = height+'px';
      }else{
        let height = document.querySelector('.login-popup-wrap').offsetHeight;
        document.querySelector('.account-popup-wraper').style.height = height+'px';
      }
      if(document.querySelector('body').classList.contains('active-popup')){
        document.querySelector('.overlay-box').style.zIndex = 1;
      }
    });
  }
});
if(document.getElementById('register-first')) document.getElementById('register-first').addEventListener('click', function(e){
  e.preventDefault();
  let height = document.querySelector('.register-popup-wrap').offsetHeight;
  document.querySelector('.account-popup-wraper').style.height = height+'px';
  document.querySelector('.account-popup-wraper').classList.add('active-register');
});
if(document.getElementById('login-second')) document.getElementById('login-second').addEventListener('click', function(e){
  e.preventDefault();
  let height = document.querySelector('.login-popup-wrap').offsetHeight;
  document.querySelector('.account-popup-wraper').style.height = height+'px';
  document.querySelector('.account-popup-wraper').classList.remove('active-register');
});
if(document.getElementById('back-to-login')) document.getElementById('back-to-login').addEventListener('click', function(e){
  e.preventDefault();
  recoverform.style.display = 'none'; 
  loginform.style.display = 'block';
  regback.style.display = 'block';
});
if(document.getElementById('forgot-password')) document.getElementById('forgot-password').addEventListener('click', function(e){
  e.preventDefault();
  recoverform.style.display = 'block'; 
  loginform.style.display = 'none';
  regback.style.display = 'none';
});
// Function to toggle password visibility
function togglePasswordVisibility(passwordSelector, iconSelector) {
  document.querySelectorAll(iconSelector).forEach(function(element) {
    element.addEventListener('click', function() {
      var passwordInput = this.parentElement.querySelector(passwordSelector);
      if (passwordInput.type === "password") {
        passwordInput.type = "text";
      } else {
        passwordInput.type = "password";
      }
    });
  });
}
togglePasswordVisibility('.display-pass', '.password-svg');
togglePasswordVisibility('.dis-reg-pass', '.reg-password-svg');
if (window.innerWidth <= 991) {
  document.addEventListener('DOMContentLoaded', () => {
    if(document.getElementById('mb-signin')) document.getElementById('mb-signin').addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('body').classList.add('active-popup');
        if(document.querySelector('body').classList.contains('active-popup')){
          document.querySelector('.mob-menuwrap').style.transform = "translate(-100%)";
        }else{
          document.querySelector('.mob-menuwrap').style.transform = "translate(0%)";
        }
    });
    document.querySelectorAll('.back-main-login,.back-main-reg-login').forEach(function(mainlogin){
      mainlogin.addEventListener('click',function(e){
        document.querySelector('body').classList.remove('active-popup');
        document.querySelector('.mob-menuwrap').style.transform = "translate(0%)";
      });
    });
  });
}